import React from "react";
import "../../../src/assets/css/home.css";

const images = [
    { icon: "/assets/images/Home/Cert4.png", title: "Innovative Solutions" },
    { icon: "/assets/images/Home/Cert3.png", title: "Sustainable Practices" },
    { icon: "/assets/images/Home/Cert2.png", title: "Trusted by Retailers" },
    { icon: "/assets/images/Home/Cert1.png", title: "Certified Quality" },
];

export default function ImageLayout() {
    return (
        <section
            className="certifications-section pb-5"
        >
            <div className="text-center">
                <h2 className="text-primary py-5" data-aos="fade-up">
                    Certifications Offered
                </h2>

                <div className="certifications" data-aos="fade-left">
                    {images.map((img, idx) => (
                        <img
                            key={idx}
                            src={img.icon}
                            alt={img.title}
                            className="img-fluid"
                            style={{
                                maxWidth: "300px",
                                objectFit: "contain",
                            }}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

//const certifications = [
//    { text: "IGI" },
//    { text: "SSGL" },
//    { text: "RESPONSIBLE" },
//    { text: "JEWELLERY" },
//    { text: "COUNCIL" },
//];

//export default function Certifications() {
//    return (
//        <section className="certifications-section container py-5">
//            <div className="container text-center">
//                <h1 className="mb-5 fw-bold text-primary">Certifications Offered</h1>
//                <div className="certifications-grid mb-5">
//                    {certifications.map((cert, idx) => (
//                        <div key={idx} className="cert-item">
//                            <span className="cert-text">{cert.text}</span>
//                        </div>
//                    ))}
//                </div>
//            </div>
//        </section>
//    );
//}
